import {
  // saveTotals,
  // saveDescriptionOfMerchandiseField,
  saveDescriptionOfMerchandiseLineItem,
  saveDutyFromHts,
  saveDutyAndFeeFromHts,
  saveDescriptionOfMerchandiseDutyItemArray
} from '../api/setFormData'
import React, { Component } from 'react'
import { pgaFlagTypeList } from '../formSections/pga/constantsPGA'
import _ from 'lodash' 
import { confirmAlert } from "react-confirm-alert";
import { saveWholeInvoice } from '../actions/DescriptionOfMerchandiseActions';


export const isWarehouseEntry = entryTypeInfo =>{
  return entryTypeInfo?.entryType=="31"
}

//copied to sumTotalCharges
export const sumGrossWeight = invoiceItems => {
  let grossWeight = 0
  var lineItemWeight
  let totalLineItems = []
  invoiceItems.forEach(invoiceItem => {
    invoiceItem.merchandiseLineItems.forEach(lineItem => {
      totalLineItems.push(lineItem)
    })
  })
  totalLineItems.forEach(lineItem => {
    if(lineItem.articleHeader != "V"){
   if (lineItem.grossWeight.weightUnits === 'LB') {
      lineItemWeight = (parseFloat(lineItem.grossWeight.weight) * 0.453592).toFixed(2)
    } else lineItemWeight = lineItem.grossWeight.weight
    grossWeight = grossWeight + parseFloat(lineItemWeight)
    }
  })
  return parseFloat(grossWeight).toFixed(2)
}
const  deepCompareWithDepth = (obj1, obj2, depth) => {
  if(obj1 === obj2)return true;
  if(depth < 5){
    console.log('depth: ', depth,obj1,obj2);
  }
  if (depth === 0) {
    return true;
  }
  if(typeof obj1 == "function" || typeof obj2 == "function"){
    return (typeof obj1) == (typeof obj2)
  }
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || !obj1 || !obj2) {
    return obj1 === obj2;
  }

  const isArray1 = Array.isArray(obj1);
  const isArray2 = Array.isArray(obj2);

  if (isArray1 !== isArray2) {
    return false;
  }


  if (isArray1) {
    if (obj1.length !== obj2.length) {
      return false;
    }
    if(!obj1.length)return true;
    // console.log('11obj1[i], obj2[i]: ', obj1, obj2);

    for (let i = 0; i < obj1.length; i++) {
      if (!deepCompareWithDepth(obj1[i], obj2[i], depth - 1)) {
        
        return false;
      }
    }

    return true;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (const key of keys1.filter(aaaa=>!["type","elementType","_debugOwner","_owner","_self","_source","_iterator"].includes(aaaa)) ) {
    if (!deepCompareWithDepth(obj1[key], obj2[key], depth - 1)) {
      return false;
    }
  }

  return true;
}

export const ch82SetHtses = ["8205906000", "8206000000", "8211100000", "8215100000", "8215200000"];

export const propsAreEqual_NoRerenderNeeded = (prop1,prop2) => {
  const theyAreEqual = deepCompareWithDepth(prop1,prop2,50);
  return theyAreEqual;
}

// export const sumTotalValue = lineItems => {
//   let updatedTotalValue = 0
//   var enteredValue
//   lineItems.forEach(lineItem => {
//     let merchandiseDuties = lineItem.merchandiseDuties
//     merchandiseDuties.forEach(duty => {
//       if (duty.isCommodityDuty === 1) {
//         enteredValue = duty.enteredValue
//         updatedTotalValue =
//           parseFloat(enteredValue) + parseFloat(updatedTotalValue)
//       }
//     })
//   })
//   return parseFloat(updatedTotalValue).toFixed(2)
// }


export const hasanyvaluesAdcvd =(mylocaladcvdval,adorcvd)=>{
  if(!mylocaladcvdval)return false;
  if(!mylocaladcvdval[adorcvd])return false;
  let hasvaluethisvar = (varxx)=>{
    return varxx && varxx != "0.00" && varxx != '_BLANK_'&& varxx != '-999'&& varxx != '_DELETE_';
  }
  return hasvaluethisvar(mylocaladcvdval[adorcvd].caseDepositRate)||
      hasvaluethisvar(mylocaladcvdval[adorcvd].caseNo) ||
      hasvaluethisvar(mylocaladcvdval[adorcvd].dutyAmount) ||
      hasvaluethisvar(mylocaladcvdval[adorcvd].caseRateCode) ||
      hasvaluethisvar(mylocaladcvdval[adorcvd].claimCode) ||
      hasvaluethisvar(mylocaladcvdval[adorcvd].specialQuantity) ||
      hasvaluethisvar(mylocaladcvdval[adorcvd].specialValue);

}

export const calculateLineItemWeightsBasedOnGrossWeightAndTotalValue = (
  grossWeight,
  grossWeightUnit,
  invoices
) => {
    
  const getSumOfDuties = (lineitems) => {
    let rettotalValue = 0;
    for (let _item of lineitems) {
      let appendvalue = _item.isCommodityDuty == 1;///
      if (appendvalue) {
        rettotalValue += parseFloat(_item.adjustedValue) >= 0.01 ?
          parseFloat(_item.adjustedValue) : parseFloat(_item.enteredValue)
      }
    }
    return rettotalValue;

  };

  let totalValue = 0;
  (invoices || []).forEach(invoiceItem => {
    invoiceItem.merchandiseLineItems.forEach(lineItem => {
      if (lineItem.articleHeader !== 'V') {
        totalValue += getSumOfDuties(lineItem.merchandiseDuties)
      }
    })
  })

  if (parseFloat(totalValue) !== 0 && invoices.length >= 1) {
    let factor = parseFloat(grossWeight) / parseFloat(totalValue)
    invoices.forEach(invoiceItem =>{
      let merchandiseItemList = [];
      let oldWeights = [];
      invoiceItem.merchandiseLineItems.forEach(lineItem => {
        oldWeights.push(parseInt(lineItem.grossWeight.weight));
        if(lineItem.articleHeader!=='V' || true){
          let enteredVal = getSumOfDuties(lineItem.merchandiseDuties)
          const kginalb = 0.45359237;
           let weight = parseFloat(
              parseFloat(enteredVal) * factor
            )
            if (
              grossWeightUnit &&
              grossWeightUnit.toUpperCase() === 'KG' &&
              lineItem.grossWeight.weightUnits === 'LB'
            ) {
              lineItem.grossWeight.weight = (weight / kginalb).toFixed(2)
            } else if (
              grossWeightUnit &&
              grossWeightUnit.toUpperCase() === 'LB' &&
              lineItem.grossWeight.weightUnits === 'KG'
            ) {
              lineItem.grossWeight.weight = (weight * kginalb).toFixed(2)
            } else {
              lineItem.grossWeight.weight = (weight).toFixed(2)
              if (grossWeightUnit && grossWeightUnit.toUpperCase() === 'LB') {
                lineItem.grossWeight.weightUnits = 'LB'
              }
              if (grossWeightUnit && grossWeightUnit.toUpperCase() === 'KG') {
                lineItem.grossWeight.weightUnits = 'KG'
              }
            }
            lineItem.grossWeight.weight = Math.round(Math.max(lineItem.grossWeight.weight,1.00)).toFixed(2)
            // saveDescriptionOfMerchandiseLineItem(
            //   lineItem.merchandiseId,invoiceItem.invoiceId,
            //   'grossWeight',
            //   lineItem.grossWeight,
            //   {}
            // )
                  
            merchandiseItemList.push({
              merchandiseId     : lineItem.merchandiseId,
              articleSetId      : lineItem.articleSetId,
              grossWeight : lineItem.grossWeight
            })
    
          }     
      })
    console.log('oldWeigxhts: ', oldWeights,merchandiseItemList.map(aaa=>parseInt(aaa?.grossWeight?.weight)),_.isEqual(oldWeights,merchandiseItemList.map(aaa=>parseInt(aaa?.grossWeight?.weight))));
    if(!_.isEqual(oldWeights,merchandiseItemList.map(aaa=>parseInt(aaa?.grossWeight?.weight)))){
      saveDescriptionOfMerchandiseDutyItemArray(invoiceItem.invoiceId, merchandiseItemList)
    }
    })
  }
  return invoices
}

export const updateDutyAndFee = (newLineItems, htsList) => {
  newLineItems.forEach(lineItem => {
    let merchandiseId = lineItem.merchandiseId
    lineItem.merchandiseDuties.forEach(dutyItem => {
      if (dutyItem.isCommodityDuty === 1) {
        dutyItem.duty = parseFloat(htsList[dutyItem.htsus].duty).toFixed(2)
        dutyItem.mpf.fee = parseFloat(htsList[dutyItem.htsus].mpfVal).toFixed(2)
        dutyItem.hmf.fee = parseFloat(htsList[dutyItem.htsus].hmfVal).toFixed(2)
        saveDutyAndFeeFromHts(
          merchandiseId,
          dutyItem.merchandiseDutyId,
          dutyItem.duty,
          dutyItem.mpf.fee,
          dutyItem.hmf.fee,
          dutyItem.isCommodityDuty
        )
      } else if (dutyItem.isCommodityDuty !== 1) {
        dutyItem.duty = parseFloat(htsList[dutyItem.hts].duty).toFixed(2)
        saveDutyFromHts(
          merchandiseId,
          dutyItem.merchandiseDutyId,
          dutyItem.duty,
          dutyItem.isCommodityDuty
        )
      }
    })
  })
  return newLineItems
}

export const inCompletedPgaStatus =  (merchandiseData) => {
  let inCompletedPga = [];
  
  

  for(let invoiceIndex=0; invoiceIndex < merchandiseData.length; invoiceIndex++){
    if(!merchandiseData[invoiceIndex]?.merchandiseLineItems)continue;
    for(let merchandiseIndexi=0; merchandiseIndexi < merchandiseData[invoiceIndex].merchandiseLineItems.length; merchandiseIndexi++){
      let locationString = `(Invoice ${(invoiceIndex + 1).toString().padStart(3, '0')}) (Merchandise ${(merchandiseIndexi + 1).toString().padStart(3, '0')}):`
      let mymerchkk = merchandiseData[invoiceIndex].merchandiseLineItems[merchandiseIndexi]
      let selectedPgas = (mymerchkk.pgaFlagInfos||[]).map(a=>a.formType||a.pgaType);
      let hasFDADisclaimPga = selectedPgas.includes("DISCLAIM_PGA")
      //detect required flags that aren't being addressed
      let merchandiseDuty = mymerchkk.merchandiseDuties.find((_item) => {
        return (_item.isCommodityDuty === 1);
      })
      let tarriffPgaDetails = _.get(merchandiseDuty, 'hsDataDtl.pgaMetadata.tarriffPgaDetails', [])
      for (let oneRequiredPGA of tarriffPgaDetails) {
        if(hasFDADisclaimPga){
          selectedPgas=selectedPgas.concat([	
            "FDA_BIO","FDA_COS","FDA_DEV","FDA_DRU","FDA_FOO","FDA_RAD","FDA_TOB","FDA_VME"])
        }
        let hasThisPga = _.intersection(selectedPgas, oneRequiredPGA?.programDetails?.map(a => a.formType))
        if (!hasThisPga || !hasThisPga.length) {
          inCompletedPga.push({
            "merchandiseId": mymerchkk['merchandiseId'],
            "fieldmessage": `${locationString} PGA program ${oneRequiredPGA?.programName}: Select a program`, "fieldmessagetype": "FAIL"
          })
        }
      }
      

      //detect incomplete flags
      for(let oneFlag of mymerchkk.pgaFlagInfos||[]){
        if(oneFlag.isOnlyForDisclaim)continue;
        if(hasFDADisclaimPga && oneFlag.formType.indexOf("FDA_") == 0){
          inCompletedPga.push({"merchandiseId": mymerchkk['merchandiseId'], "fieldmessage": `${locationString} #PGA : ${oneFlag.formType} is not allowed if there's a FDA DISCLAIM present`, "fieldmessagetype": "FAIL"});
          continue;
        }
        if(oneFlag.formType == "DISCLAIM_PGA")continue;//disclaim pga requires no info
        if(oneFlag.pgaFlagStatus != '1'){
          inCompletedPga.push({"merchandiseId": mymerchkk['merchandiseId'], "fieldmessage": `${locationString} #PGA : ${oneFlag.formType} is not completed`, "fieldmessagetype": "FAIL"})
        }
      }
              
      
    }
  }
  return inCompletedPga;
}

export const validationForRequiredFields = (completeStore, updateType) => {
  let error = []
  const merchandises = completeStore.DescriptionOfMerchandise;
  const merchandiseData = merchandises.entrySummaryInvoices;
  const entryType = completeStore.EntryTypeInfo;
  const transportation = completeStore.TransportationInfo;
  const declaration = completeStore.DeclarationSection;
  const fieldValidations = completeStore.FieldValidation;
  const BOLInfo = completeStore.BOLInfo;
    let totalValue = merchandises.totalValue;
  let isCwCompleted = true;
  if(fieldValidations){
    if(fieldValidations.fields.length){
      fieldValidations.fields.map((item)=>{
        if(!(item.overrideCodeUsed || item.valueChanged === 1) && item.isWarningResolved == 2 ){
          isCwCompleted = false;
        }
      })
    }
  }


  let priorityErrors = ((fieldValidations.warnings||[]).filter(a=>a.priorityErrorFinalReview));
  if(priorityErrors.length){
    
    setTimeout(()=>{
      let nameofWarningTabOnUI = "nameOfWarningTab"+priorityErrors[0].tab;
      document.getElementsByClassName(nameofWarningTabOnUI) && 
        document.getElementsByClassName(nameofWarningTabOnUI)[0] && 
          document.getElementsByClassName(nameofWarningTabOnUI)[0].click();
    },20)
    
    
    setTimeout(()=>{
      let hideerrorbutton= document.getElementsByClassName("hideError")[0];
      if(hideerrorbutton){
        let warningBoxAboveFormcontentarea = document.getElementsByClassName("warningBoxAboveFormcontentarea")[0];
        if(warningBoxAboveFormcontentarea && warningBoxAboveFormcontentarea.children[0]){
          warningBoxAboveFormcontentarea.children[0].click();
        }
      }
      let warningbox = document.getElementsByClassName("warningBoxAboveFormcontentarea")[0];
      if(warningbox){
        warningbox.classList.add("flashfxx");
        setTimeout(()=>{
          warningbox.classList.remove("flashfxx");
        },650)
      }
    },60)
    error.push({"fieldmessage":`Complete required PGAs`, "fieldmessagetype": "NOSHOW"})
  }
  let popupwarns = (fieldValidations.warnings||[]).filter(a=>a.popupWarnFinalReview);
  if(!window.ignorewarningpopup  && popupwarns && popupwarns.length){
    let htmtttmtml = <div style={{maxHeight:'20vh',overflowY:'scroll',border:'1px dashed gray'}}>{popupwarns.map((onewarn,iii)=>{
      return <div key={onewarn.msg+onewarn.location+" htgf"+iii}><b>{onewarn.location}</b> {onewarn.msg}</div>
    })

    }
    </div>;
    confirmAlert({
      overlayClassName: 'bigConfirmAlert',
      title: "These warnings are not critical. Do you want to ignore them?",
      message: htmtttmtml,
      buttons: [
        {
          label: "Ignore",
          onClick: () => {
            window.ignorewarningpopup = true
            document.getElementById("FINAL_REVIEW").click();
          },
        },
        {
          label: "Back",
          onClick: () => {
          }
        }
      ],
    });
    error.push({"fieldmessage":`${popupwarns[0].location} ${popupwarns[0].msg}`, "fieldmessagetype": "FAIL"})
  }
  
  let isEntirelyUSandChapter98 = true;
  for(let oneinvoice of (merchandiseData||[])){
    for(let onelineitem of (oneinvoice.merchandiseLineItems||[])){
      if(onelineitem.countryOfOrigin != "US")isEntirelyUSandChapter98=false;
      for(let oneDutyItem of (onelineitem.merchandiseDuties||[])){
        if((oneDutyItem.htsus||"").indexOf("98")!=0)isEntirelyUSandChapter98 = false;
      }
      if(!isEntirelyUSandChapter98)break;
    }
    if(!isEntirelyUSandChapter98)break;
  }


  let maxShipmentValue = isEntirelyUSandChapter98?10000:2500;
  if(!completeStore.PSC.pscShipmentId && !window.ignore && totalValue <= maxShipmentValue && entryType.entryType!= 11){
    confirmAlert({
      title: "Confirmation!",
      message: `The total shipment value is less than or equal to $${maxShipmentValue}, so entry type can be selected as "11 - Informal" which will reduce the shipment MPF. Do you want to go back and change the entry type?`,
      buttons: [
        {
          label: "YES",
          onClick: () => {
            document.getElementsByClassName("bolAwbInfo")[0].click();
            window.ignore = false;
          },
        },
        {
          label: "NO",
          onClick: () => {
            window.ignore = true
            document.getElementById("FINAL_REVIEW").click();
          }
        }
      ],
    });
    error.push({"fieldmessage":`The total shipment value is less than or equal to $${maxShipmentValue}, so entry type can be selected as "11 - Informal" which will reduce the shipment MPF. Do you want to go back and change the entry type?" `, "fieldmessagetype": "FAIL"})
  }
  if(totalValue > maxShipmentValue && entryType.entryType == 11){
    error.push({"fieldmessage":`The total shipment value exceeds $${maxShipmentValue}, so the "11 - Informal" entry type is not permitted. Please select an appropriate entry type.`, "fieldmessagetype": "FAIL"})
  }
  if(!isCwCompleted && (updateType === "combined" || updateType === "entryUpdate")){
    error.push({"fieldmessage":`All the census warnings are not marked resolved. If a census warning override is Filed, wait for it to be in Accepted or Rejected state.`, "fieldmessagetype": "FAIL"})
  }
  merchandiseData.forEach((invoiceItem, index) => {
    invoiceItem.merchandiseLineItems.forEach((lineItem,_index) => {
      if(lineItem.grossWeight){
        if(!lineItem.grossWeight.weightUnits || lineItem.grossWeight.weightUnits === "_BLANK_" || !lineItem.grossWeight.weight || lineItem.grossWeight.weight== 0){
          error.push({"fieldmessage":`Line Item weight is required - Invoice: #00${index+1} Line: #00${_index+1}`, "fieldmessagetype": "FAIL"})
        }
      }
      if(lineItem.merchandiseDuties){
        lineItem.merchandiseDuties.map((dutyItem, __index)=>{
          if(dutyItem.isValidHts === false){
            error.push({"fieldmessage":`"${dutyItem.htsus}" is not a valid HTS - Invoice: #00${index+1} Line: #00${_index+1}`, "fieldmessagetype": "FAIL"})
          }
          if(dutyItem.additionalQuantity){
            if(dutyItem.additionalQuantity.units && dutyItem.additionalQuantity.units !== "_BLANK_" && (!dutyItem.additionalQuantity.quantity || dutyItem.additionalQuantity.quantity== 0)){
              error.push({"fieldmessage":`Additional quantity is required when the unit of measurement is present - Invoice: #00${index+1} Line: #00${_index+1}`, "fieldmessagetype": "FAIL"})
            }
          }
          // if(dutyItem.manifestQuantity){
          //   if(dutyItem.manifestQuantity.units && dutyItem.manifestQuantity.units !== "_BLANK_" && (!dutyItem.manifestQuantity.quantity || dutyItem.manifestQuantity.quantity == 0)){
          //     error.push({"fieldmessage":`Manifest quantity is required when the unit of measurement is present - Invoice: #00${index+1} Line: #00${_index+1}`, "fieldmessagetype": "FAIL"})
          //   }
          // }
        })
      }
    })
  })
  merchandiseData.forEach((invoiceItem,invoiceIndexa) => {
    if(!invoiceItem.merchandiseLineItems || invoiceItem.merchandiseLineItems.length == 0){
      error.push({"fieldmessage":`Invoice ${invoiceIndexa+1}: No merchandise line items`, "fieldmessagetype": "FAIL"})

    }
  })
  let ignorevalidation = ['cargoReleaseUpdate','entryUpdate'].includes(updateType) || _.get(completeStore,"PSC.pscShipmentId") || isWarehouseEntry(entryType);
  const incompletePga = ignorevalidation?[]:inCompletedPgaStatus(merchandiseData);
  if(!transportation.USportOfUnladingCode || (transportation.USportOfUnladingCode && !transportation.USportOfUnladingCode.id)){
      error.push({"fieldmessage":"Entry Type: US Port of unlading is missing", "fieldmessagetype": "FAIL"})
  }
  // if(!transportation.foreignPortOfLadingCode || (transportation.foreignPortOfLadingCode && !transportation.foreignPortOfLadingCode.id)){
  //     error.push({"fieldmessage":"Transportation: Foreign Port of lading is missing", "fieldmessagetype": "FAIL"})
  // }

 
  let isEngineView = window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN == 'kxEngineBrokerToken';
  if (!isEngineView) {
    if (BOLInfo.itNumber.length && BOLInfo.itNumber !== "_BLANK_") {
      if (!BOLInfo.itDate?.epochs || BOLInfo.itDate.epochs == "-999") {
        error.push({ "fieldmessage": "I.T.DATE is required with I.T.NUMBER", "fieldmessagetype": "FAIL" })
      }
    }

    if (BOLInfo.itDate?.epochs && BOLInfo.itDate.epochs !== -999) {

      if (!(BOLInfo.itNumber.length) || BOLInfo.itNumber == "_BLANK_") {
        error.push({
          "fieldmessage": "I.T.NUMBER is required with I.T.DATE", "fieldmessagetype": "FAIL"

        })
      } else if (!BOLInfo.itNumber.match(/^[a-z0-9]+$/gi)) {
        error.push({
          "fieldmessage": "I.T.NUMBER is alphanumeric", "fieldmessagetype": "FAIL"
        })
      }
    }

    if (BOLInfo.itDate?.epochs && BOLInfo.itDate.epochs !== -999) {
      if (BOLInfo.itDate.epochs && entryType.summaryDate?.epochs) {
        const diff = Math.abs(BOLInfo.itDate.epochs - entryType.summaryDate?.epochs)
        if (diff > 31556926000) {
          error.push({
            "fieldmessage": 'IT Date must be within 12 months of entry date', "fieldmessagetype": "FAIL"
          })
        }
      }
    }
  } else if (isEngineView) {
    const itNumber=BOLInfo?.engineBolInfo?.engineBolRecord?.find((rec)=>rec?.itNumber)?.itNumber

    const hasItNumber = itNumber && itNumber !== "_BLANK_";
    const hasItDate = BOLInfo?.itDate?.epochs && BOLInfo?.itDate.epochs !== -999;
    
    if (hasItNumber && !hasItDate) {
      error.push({
        fieldmessage: "I.T.DATE is required with I.T.NUMBER",
        fieldmessagetype: "FAIL"
      });
    }
  
    if (hasItDate && !hasItNumber) {
      error.push({
        fieldmessage: "I.T.NUMBER is required with I.T.DATE",
        fieldmessagetype: "FAIL"
      });
    }
  }

  
  if(!entryType.portCode || !entryType.portCode.id){
      error.push({"fieldmessage":"Entry type PortCode is missing", "fieldmessagetype": "FAIL"})
  }
  if(!((declaration.trueInvoiceFlag == 1 || declaration.bestInvoiceFlag == 1) && (declaration.actualOwnerFlag == 1 || declaration.purchaserFlag == 1))){
    error.push({"fieldmessage":"Sign is not completed", "fieldmessagetype": "FAIL"})
  }
  if(completeStore.PSC.pscShipmentId && (!completeStore.PSC.headerCodes && !completeStore.PSC.lineCodes)){
    error.push({"fieldmessage":"PSC reason(s) are missing", "fieldmessagetype": "FAIL"})
  }
  if(completeStore.PSC.pscShipmentId && !completeStore.PSC.pscFileExplanation){
    error.push({"fieldmessage":"PSC explanation is missing", "fieldmessagetype": "FAIL"})
  }
  if(completeStore.PSC.pscShipmentId && !completeStore.PSC.accelaratedLiquidation){
    error.push({"fieldmessage":"PSC liquidation option is not selected!", "fieldmessagetype": "FAIL"})
  }
  if(completeStore.PSC.pscShipmentId && completeStore.PSC.confirmPSC!=1){
    error.push({"fieldmessage":"Please Confirm the Post Summary Correction!", "fieldmessagetype": "FAIL"})
  }
  if(incompletePga?.length){
      error = error.concat(incompletePga)
  }
  return error;
}
